export default __webpack_public_path__ + "media/color/blz-c628fe85.svg";